import React from "react";
import { Plus } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function ChecklistAddItem({ activeTab, value, onChange, onAdd }) {
  return (
    <div className="border-t border-[#DCD4C6] pt-4">
      <p className="text-xs uppercase tracking-widest text-[#8B5E34] mb-2" style={LORA}>
        Ajouter un élément personnalisé
      </p>
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onAdd()}
          placeholder="Ex : Médicaments sur ordonnance..."
          className="flex-1 border border-[#DCD4C6] bg-white px-3 py-2.5 text-sm text-[#2B2623] placeholder-[#C8C0B8] focus:outline-none focus:border-[#C17F59] transition-colors"
          style={{ ...LORA, borderRadius: "2px" }}
          data-testid={`input-custom-${activeTab}`}
        />
        <button
          onClick={onAdd}
          disabled={!value?.trim()}
          className="px-4 py-2.5 bg-[#C17F59] text-[#F9F6F0] hover:bg-[#A86A46] disabled:opacity-40 transition-colors flex-shrink-0"
          style={{ borderRadius: "2px" }}
          data-testid={`btn-add-${activeTab}`}
        >
          <Plus size={16} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
